import { create } from "zustand";

type Banner = {
  id: number;
  title: string;
  sub_title: string;
  image_desktop: string;
  image_mobile: string;
  button_url: string;
};

type BannerStore = {
  banners: Banner[];
  fetchBanners: (lang: "en" | "id") => Promise<void>;
};

const baseUrl = "https://admin-talentlink.digiline.id/api";



export const useBannerStore = create<BannerStore>((set) => ({
  banners: [],

  fetchBanners: async (lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/banner`);
      if (!res.ok) throw new Error("Failed to fetch banners");

      const json = await res.json();
      set({ banners: json.data || [] });
    } catch (error) {
      console.error("Failed to fetch banners:", error);
    }
  },
}));
